<template>
  <div class="depth-map-com" ref="depth_map_com">
    <!-- {{depthmap}} -->
    <highcharts :options="depthmap" ref="depthmapH"></highcharts>
  </div>
</template>

<script>
import tool from '../../../../common/js/tool';
import { Chart } from 'highcharts-vue';
import { mapGetters } from 'vuex';
import { getterTypes } from '../../../../store/getter-types';
import i18n from '@/translations';
import BigNumber from 'bignumber.js';

let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
const INDEX_PRICE = 0;
const INDEX_VOLUME = 1;

const READY = 0;
const LOADING = 1;

export default {
  name: 'DepthChart',
  data() {
    let _that = this;
    return {
      //new data
      renderData: null,
      data: null,
      loading: true,
      queue: null,
      interval: null,
      autoMerge: false,
      autoMergeDelay: 500,
      buyQueue: null,
      sellQueue: null,
      buyData: null,
      sellData: null,
      state: READY,
      latestPrice: null,
      latestPriceUpperLimit: null,
      latestPriceLowerLimit: null,
      latestPriceOffset: !window.env.depthGraphPriceOffset ? 10 : window.env.depthGraphPriceOffset,
      depthGraphMaxDataSet: !window.env.depthGraphMaxDataSet ? 200 : window.env.depthGraphMaxDataSet,

      //old data
      unit: null,
      depthGraphData: {
        buy: [],
        sell: []
      },
      // 上次重绘时间
      lastRedrawTime: null,
      // 深度图对象
      depthmapHc: null,
      // 深度图是否第一次加载
      firstLoad: true,
      // 深度图highcharts配置
      depthmap: {
        colors: ['#087c0b', '#ab2b24'],
        chart: {
          type: 'area',
          animation: false,
          backgroundColor: '#1f222b'
        },
        title: {
          text: '深度图',
          style: {
            display: 'none'
          }
        },
        loading: {
          style: {
            color: '#fff',
            backgroundColor: 'transparent'
          }
        },
        legend: {
          symbolRadius: 0,
          squareSymbol: false,
          itemStyle: {
            color: '#88887c'
          },
          title: {
            /*text: this.$t('dealProfessional.price'), // 价格
            style: {
              width: '100%',
              color: '#707070',
              textAlign: 'center'
            }*/
          }
        },
        subtitle: {
          text: ''
        },
        credits: {
          text: '',
          href: ''
        },
        xAxis: {
          // 刻度文字对面显示
          opposite: false,
          // 轴线颜色
          lineColor: '#c0d0e0',
          tickColor: '#c0d0e0',
          labels: {
            style: {
              color: '#939498'
            }
          },
          maxPadding: 0.03
        },
        yAxis: {
          // 刻度文字对面显示
          opposite: true,
          // 网格线颜色
          gridLineColor: '#353841',
          // 网格线样式
          gridLineDashStyle: 'Dash',
          // 轴标签，即刻度文字
          labels: {
            align: 'right',
            style: {
              color: '#888'
            }
          },
          // 轴线宽度，即紧挨刻度文字的那条线
          lineWidth: 0,
          // 即刻度线宽度
          tickWidth: 0
        },
        // tooltip: false,
        tooltip: {
          shared: !0,
          formatter: function() {
            return (
              i18n.t('dealProfessional.price') +
              ':' +
              this.points[0].x +
              '<br>' +
              i18n.t('dealProfessional.sum') +
              ':' +
              this.points[0].y +
              ' '
            );
            // return this.points[0].x + '<br>' + this.points[0].y + ' ' + _that.currentMarket.name.split('/')[0];
            // return "委 托 价 ：" + '￥'+ this.points[0].x + "<br>" + this.points[0].series.name + "：" + '累计数量' + Math.round(this.points[0].y)
          }
        },
        plotOptions: {
          area: {
            pointStart: 0,
            marker: {
              enabled: !1,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: !0
                }
              }
            }
          }
        },
        series: [
          {
            name: this.$t('dealProfessional.buyEntrust'), // 买盘委托
            fillOpacity: 1,
            lineColor: '#090',
            data: []
          },
          {
            name: this.$t('dealProfessional.sellEntrust'), // 卖盘委托
            fillOpacity: 1,
            lineColor: '#da2e22',
            // lineWidth: 3,
            data: []
          }
        ]
      }
    };
  },
  props: {
    buyChart: {
      type: Array,
      default: []
    },
    sellChart: {
      type: Array,
      default: []
    },
    // 深度图数据，包含买入数据、卖出数据
    propDepthGraphData: {
      type: Object,
      default() {
        return {};
      }
    },
    // 当前市场
    currentMarket: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    socketDepthGraphData: {
      type: Object,
      default() {
        return {
          buy: {},
          sell: {}
        };
      }
    }
  },
  components: {
    highcharts: Chart
  },
  methods: {
    init(buyData, sellData) {
      let initBuyData = [...buyData];
      let initSellData = [...sellData];
      this.mergeQueue(initBuyData, initSellData);
      // this.startAutoMerge();
    },
    startAutoMerge() {
      if (!this.autoMerge) {
        this.autoMerge = true;
        this.interval = setInterval(() => {
          if (this.buyQueue && this.sellQueue) {
            this.mergeQueue(this.buyQueue, this.sellQueue.reverse());
          }
        }, this.autoMergeDelay);
      }
    },
    mergeQueue(buyData, sellData) {
      //get price limits
      this.latestPrice = new BigNumber(this.Getter_Current_Market.close);
      this.getLatestPriceUpperLimit();
      this.getLatestPriceLowerLimit();

      if (null != buyData && undefined != buyData) {
        if (0 < buyData.length) {
          buyData = buyData.splice(0, this.depthGraphMaxDataSet);
          buyData = this.getLatestPriceLowerLimitData(buyData);
          buyData = this.createDepthData(buyData).reverse();
          this.buyData = buyData;
        } else {
          this.buyData = [];
        }
      }

      if (null != sellData && undefined != sellData) {
        if (0 < sellData.length) {
          sellData = sellData.splice(0, this.depthGraphMaxDataSet);
          sellData = this.getLatestPriceUpperLimitData(sellData);
          sellData = this.createDepthData(sellData);
          this.sellData = sellData;
        } else {
          this.sellData = [];
        }
      }

      this.draw(this.buyData, this.sellData);
    },
    onBuy(data) {
      this.buyQueue = data.map(item => {
        return [item.price, item.volume];
      });

      this.onMerge();
    },
    onSell(data) {
      this.sellQueue = data.map(item => {
        return [item.price, item.volume];
      });

      this.onMerge();
    },
    onMerge() {
      if (this.state == READY) {
        this.state = LOADING;
        let buyData = this.buyQueue;
        let sellData = this.sellQueue;
        this.mergeQueue(!buyData ? null : buyData, !sellData ? null : sellData.reverse());
        this.buyQueue = null;
        this.sellQueue = null;
      }
    },
    createDepthData(data) {
      let response = data.map(item => {
        return this.createValue(item[0], item[1]);
      });

      let volume = new BigNumber(0);
      for (let i = 0; i < response.length; i++) {
        let item = response[i];
        volume = volume.plus(new BigNumber(item[1]));
        response[i][1] = Number(volume);
      }

      return response;
    },
    createValue(price, volume) {
      if (null == volume || undefined == volume) {
        volume = 0;
      }

      return [Number(price), Number(volume)];
    },
    reset() {
      this.data = null;
      this.queue = null;
      this.interval = null;
      this.autoMerge = false;
    },
    draw(buyData, sellData) {
      this.depthmapHc.chart.hideLoading();
      this.depthmapHc.chart.update({
        series: [{ data: buyData }, { data: sellData }]
      });
      this.firstLoad = false;
      //allow redrawing every 5 sec
      setTimeout(
        () => {
          this.state = READY;
        },
        !window.env.depthGraphRefreshRate ? 5000 : window.env.depthGraphRefreshRate
      );
    },
    getLatestPriceUpperLimit() {
      this.latestPriceUpperLimit = this.latestPrice.times(
        !window.env.depthGraphSellPriceOffset ? 2 : window.env.depthGraphSellPriceOffset
      );
    },
    getLatestPriceLowerLimit() {
      this.latestPriceLowerLimit = this.latestPrice.times(
        !window.env.depthGraphBuyPriceOffset ? 0.5 : window.env.depthGraphBuyPriceOffset
      );
    },
    getLatestPriceUpperLimitData(data) {
      const response = data.filter(item => {
        let price = new BigNumber(item[0]);
        if (price.isLessThanOrEqualTo(this.latestPriceUpperLimit)) {
          return item;
        }
      });
      return response;
    },
    getLatestPriceLowerLimitData(data) {
      const response = data.filter(item => {
        let price = new BigNumber(item[0]);
        if (price.isGreaterThanOrEqualTo(this.latestPriceLowerLimit)) {
          return item;
        }
      });
      return response;
    },

    //something old
    depthData() {
      this.depthGraphData = this.propDepthGraphData;
      let test = [];
      let calBuySum = 0;
      let { sell, buy } = this.depthGraphData;

      if (buy !== undefined && buy.length > 0) {
        for (let item of buy) {
          calBuySum = calBuySum + Number(item[1]);
          test.push([Number(item[0]), calBuySum]);
        }
      }

      let resultBids = test.reverse();
      // let resultAsks = sell.reverse();
      this.redraw(resultBids, sell);
    },
    calculateDepthMapHeight() {
      let dom = this.$refs.depth_map_com;
      this.depthmapHc.chart.setSize(dom.clientWidth, dom.clientHeight, false);
    },
    // 数组累加器，根据一个数组返回累加后的数组
    arrayAccumulate: tool.arrayAccumulate,
    // 数组转换
    arrayConvert(arr) {
      let priceArr = [],
        volumeArr = [];
      arr.forEach(item => {
        priceArr.push(item.price);
        volumeArr.push(item.volume);
      });
      return {
        price: priceArr,
        volume: volumeArr
      };
    },
    // 重绘深度图
    redraw(resultBuyArr, resultSellArr) {
      let copyResultSell = JSON.parse(JSON.stringify(resultSellArr));

      var now = +new Date();
      var calResultBuyArr = [];
      var calResultSellArr = [];
      var calSellSum = 0;

      copyResultSell.reverse();

      for (let item of copyResultSell) {
        calSellSum = calSellSum + Number(item[1]);
        calResultSellArr.push([Number(item[0]), calSellSum]);
      }

      if (this.firstLoad) {
        this.depthmapHc.chart.hideLoading();
        this.depthmapHc.chart.update({
          series: [{ data: resultBuyArr }, { data: calResultSellArr }]
        });
        this.lastRedrawTime = now;

        this.firstLoad = false;
      }
      // 防止过多重绘
      if (!this.lastRedrawTime || now - this.lastRedrawTime >= 1000) {
        this.depthmapHc.chart.update({
          series: [{ data: resultBuyArr }, { data: calResultSellArr }]
        });
        this.lastRedrawTime = now;
      } else {
        this.depthmapHc.chart.update({
          series: [{ data: resultBuyArr }, { data: calResultSellArr }]
        });
      }
    },
    hasInterspersed(arr1, arr2) {
      let arr1Copy = [].concat(arr1),
        arr2Copy = [].concat(arr2),
        arr1Max = Math.max.apply(null, arr1Copy),
        arr1Index = arr1Copy.indexOf(arr1Max),
        arr2Min = Math.min.apply(null, arr2Copy);
      while (arr1Copy.length) {
        if (arr2Min < arr1Max) {
          return {
            arr1Max: arr1Max,
            arr2Min: arr2Min,
            hasInterspersed: true
          };
        } else {
          arr1Copy.splice(arr1Index, 1);
          arr1Max = Math.max.apply(null, arr1Copy);
        }
      }
    },
    findPrice(prices, target, asc) {
      const INDEX_PRICE = 0;
      if (prices.length > 0) {
        let head = 0;
        let tail = prices.length - 1;

        if (asc) {
          while (head < tail) {
            let i = Math.floor((head + tail) / 2);
            if (Number(prices[i][INDEX_PRICE]) < Number(target)) {
              head = i + 1;
            } else if (Number(prices[i][INDEX_PRICE]) > Number(target)) {
              tail = i - 1;
            } else {
              return {
                found: true,
                index: i
              };
            }
          }
          if (head == tail) {
            if (Number(prices[head][INDEX_PRICE]) == Number(target)) {
              return {
                found: true,
                index: head
              };
            } else {
              if (Number(prices[head][INDEX_PRICE]) < Number(target)) {
                head++;
              }
              return {
                found: false,
                index: head
              };
            }
          }
          return {
            found: false,
            index: head
          };
        } else {
          while (head < tail) {
            let i = Math.floor((head + tail) / 2);
            if (Number(prices[i][INDEX_PRICE]) > Number(target)) {
              head = i + 1;
            } else if (Number(prices[i][INDEX_PRICE]) < Number(target)) {
              tail = i - 1;
            } else {
              return {
                found: true,
                index: i
              };
            }
          }
          if (head == tail) {
            if (Number(prices[head][INDEX_PRICE]) == Number(target)) {
              return {
                found: true,
                index: head
              };
            } else {
              if (Number(prices[head][INDEX_PRICE]) > Number(target)) {
                head++;
              }
              return {
                found: false,
                index: head
              };
            }
          }
          return {
            found: false,
            index: head
          };
        }
      }
      return {
        found: false,
        index: 0
      };
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Current_Market, getterTypes.Getter_Current_Currency])
  },
  watch: {
    buyChart(value) {
      this.draw(value, this.sellChart);
    },
    sellChart(value) {
      this.draw(this.buyChart, value);
    },
    Getter_Current_Market() {
      let test = [];
      let calBuySum = 0;
      let { sell, buy } = this.depthGraphData;

      for (let item of buy) {
        calBuySum = calBuySum + Number(item[1]);
        test.push([Number(item[0]), calBuySum]);
      }

      let resultBids = test.reverse();
      this.redraw(resultBids, sell);
    },
    propDepthGraphData(newVal) {
      this.depthGraphData = newVal;
      let test = [];
      let calBuySum = 0;
      let { sell, buy } = this.depthGraphData;

      if (buy !== undefined && buy.length > 0) {
        for (let item of buy) {
          calBuySum = calBuySum + Number(item[1]);
          test.push([Number(item[0]), calBuySum]);
        }
      }

      let resultBids = test.reverse();
      // let resultAsks = sell.reverse();
      this.redraw(resultBids, sell);
    },
    currentMarket(newVal) {
      if (newVal) {
        this.unit = newVal.name.split('/')[1];
      }
    },
    socketDepthGraphData(newVal) {
      let depthBuy = this.depthGraphData.buy;
      let depthSell = this.depthGraphData.sell;
      let test = [];
      let test3 = [];
      let newDepthSell = [];

      if (newVal != null) {
        if (newVal.buy.length > 0) {
          let newDepthBuy = newVal.buy;

          for (let item of depthBuy) {
            test.push([item[0], item[1]]);
          }

          for (let item of newDepthBuy) {
            let { found, index } = this.findPrice(test, item[INDEX_PRICE], false);

            if (item[INDEX_VOLUME] == '' || item[INDEX_VOLUME] == '0') {
              if (found) {
                test.splice(index, 1);
              }
            } else {
              if (found) {
                test[index][INDEX_VOLUME] = item[INDEX_VOLUME];
              } else {
                test.splice(index, 0, item);
              }
            }
          }
        } else {
          for (let item of depthBuy) {
            test.push([item[0], item[1]]);
          }
        }

        if (newVal.sell.length > 0) {
          newDepthSell = newVal.sell;

          for (let item of depthSell) {
            test3.push([item[0], item[1]]);
          }

          for (let item of newDepthSell) {
            let { found, index } = this.findPrice(test3, item[INDEX_PRICE], false);

            if (item[INDEX_VOLUME] == '' || item[INDEX_VOLUME] == '0') {
              if (found) {
                test3.splice(index, 1);
              }
            } else {
              if (found) {
                test3[index][INDEX_VOLUME] = item[INDEX_VOLUME];
              } else {
                test3.splice(index, 0, item);
              }
            }
          }
          test3.reverse();
        } else {
          newDepthSell = newVal.sell;

          for (let item of depthSell) {
            test3.push([item[0], item[1]]);
          }
          test3.reverse();
        }

        let calBuySum = 0;
        let test2 = [];
        for (let item of test) {
          calBuySum = calBuySum + Number(item[1]);
          test2.push([Number(item[0]), calBuySum]);
        }

        let resultAsks = test3.reverse();

        this.redraw(test2, resultAsks);
      }
    }
  },
  mounted() {
    this.depthmapHc = this.$refs.depthmapH;
    this.depthmapHc.chart.showLoading();
    this.draw(this.buyChart, this.sellChart);
    window.addEventListener(resizeEvt, this.calculateDepthMapHeight, false);

    if (this.currentMarket) {
      try {
        this.unit = this.currentMarket.name.split('/')[1];
      } catch (error) {}
    }
  },
  beforeDestroy() {
    this.buyData = null;
    this.sellData = null;
  },
  destroyed() {
    window.removeEventListener(resizeEvt, this.calculateDepthMapHeight, false);
  }
};
</script>

<style lang="stylus" scoped>
.depth-map-com {
  // height: 100%;
}
.highcharts-axis-title {
  color: #1f222b !important;
  fill: #1f222b !important;
}
</style>
<style lang="stylus">
.depth-map-com .highcharts-axis-title {
  color: #1f222b !important;
  fill: #1f222b !important;
}
.depth-map-com .highcharts-container {
  height:360px !important;
}
</style>
